<div class="address-search">
  <div
    class="search-input"
    [class.is-field]="formField"
    [style.width]="expandSearch ? (width ?? '100%') : '40px'"
    [class.show-search]="expandSearch"
    [class.is-active]="inputHasFocus">
    @if (expandSearch && !textarea) {
      <input
        #searchInput
        (keyup.enter)="searchPlace()"
        (keyup)="navigateUsingKey($event)"
        type="text"
        placeholder="{{ 'MAP.SEARCH' | translate }}"
        [(ngModel)]="mapSearch"
        (focus)="inputHasFocus = true"
        (blur)="inputHasFocus = false" />
    }
    @if (expandSearch && textarea) {
      <textarea
        cdkTextareaAutosize
        cdkAutosizeMinRows="1"
        cdkAutosizeMaxRows="5"
        #searchInput
        (keyup.enter)="searchPlace()"
        (keyup)="navigateUsingKey($event)"
        type="text"
        placeholder="{{ 'MAP.SEARCH' | translate }}"
        [(ngModel)]="mapSearch"
        (focus)="inputHasFocus = true"
        (blur)="inputHasFocus = false"></textarea>
    }

    @if (!formField) {
      <span
        class="search"
        (click)="expandSearch ? setGeocodeResult() : openSearch()">
        <i class="icon icon-search"></i>
      </span>
    }
    @if (expandSearch && _expandable) {
      <div class="vertical-divider mx-3"></div>
      <span
        class="clear-search"
        (click)="clearMapSearch()">
        <i class="icon icon-small_close-X"></i>
      </span>
    }
  </div>
  @if (predictions.length > 0) {
    <ul
      class="predictions"
      animate.enter="enter-animation"
      animate.leave="leave-animation">
      @for (place of predictions; track place.place_id; let i = $index) {
        <li
          class="results-list-item"
          [class.active-search-link]="i === linkIndex"
          [ngClass]="{ 'section-color': i === linkIndex }">
          <div
            fxLayout="row"
            fxLayoutAlign="start start"
            (click)="searchPlace(place)">
            <div class="mr-2 pt-1">
              <i class="icon icon-pin"></i>
            </div>
            <div>
              <span>{{ place.description }}</span>
            </div>
          </div>
        </li>
      }
    </ul>
  }
</div>
